import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { Button, Container, TextField } from "@mui/material";
import { getData } from "../../../services/library";

const CambiarPrecioVianda = ({ open, onClose }) => {
  const [nuevoPrecioViandas, setNuevoPrecioViandas] = useState("");

  const esPrecioValido =
    nuevoPrecioViandas !== "" &&
    !isNaN(nuevoPrecioViandas) &&
    Number(nuevoPrecioViandas) >= 0;

  const changePrecioDeViandas = (e) => {
    setNuevoPrecioViandas(Number(e.target.value));
  };

  useEffect(() => {
    getData("/viandas/menu/obtenerPrecioViandas/gg?id_tipo=320", (data) => {
      setNuevoPrecioViandas(data[0]?.valor);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!esPrecioValido) {
        console.warn("Precio inválido");
        return;
      }

      const response = await fetch(
        `${UrlApi}/viandas/pedidos/actualizarPrecioVianda`,
        {
          method: "PUT",
          body: JSON.stringify({ precio: nuevoPrecioViandas }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar el precio de las viandas");
      }

      console.log("Precio de viandas actualizado correctamente");
      onClose();
    } catch (error) {
      console.error("Error al cambiar el precio de la vianda:", error);
    }
  };

  if (!open) return null;

  return (
    <Container maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Nuevo Precio de Viandas"
          type="number"
          value={nuevoPrecioViandas}
          onChange={changePrecioDeViandas}
          required
          margin="normal"
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!esPrecioValido}
          fullWidth
        >
          Actualizar Precio
        </Button>
      </form>
    </Container>
  );
};

export default CambiarPrecioVianda;
